<template>
  <div class="content-wrapper">
    <div class="content-header row">
      <div class="content-header-left col-md-9 col-12 mb-2">
        <Breadcrumb
            name="Staff"
            bc1="Merchant"
            bc2="Staff"
            bc3="Kyc Update Details"
        ></Breadcrumb>
      </div>
      <div class="col-3">
        <div class="d-flex align-items-center justify-content-end">
          <button
              type="button"
              class="btn btn-gradient-danger btn-sm"
              @click="backTo"
          >
            <span class="text-nowrap">Back</span>
          </button>
        </div>
      </div>
      <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
      >
      </div>
    </div>
    <div class="content-body">
      <section class="app-user-list">
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card border-primary badge-glow">
                <div class="card-header">
                  <h4 class="card-title">Staff Kyc Details</h4>
                </div>
                <div class="card-body table-responsive ">
                  <div class="row">
                    <table class="table table-head-fixed table-hover-animation text-nowrap">
                      <thead>
                      <tr>
                        <th>S.no</th>
                        <th>Applicant Id</th>
                        <th>Status</th>
                        <th>Updated By</th>
                        <th>Reason</th>
                        <th>Updated At</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr  v-for="(eachUserkycsArrayElement,eachUserkycsArrayElementIndex) in userkycs" :key="eachUserkycsArrayElementIndex">
                        <td>{{ eachUserkycsArrayElementIndex + 1 }}</td>
                        <td><span class="text-primary">{{eachUserkycsArrayElement.applicant_id}}</span></td>
                        <td>
                          <span class="text-warning" v-if="eachUserkycsArrayElement.status == 2" >Pending</span>
                          <span class="text-success" v-else-if="eachUserkycsArrayElement.status == 1" >Verified</span>
                          <span class="text-info" v-else-if="eachUserkycsArrayElement.status == 3" >Upload Document Again</span>
                          <span class="text-danger" v-else-if="eachUserkycsArrayElement.status == 4" >Blocked</span>
                          <span class="text-dark" v-else-if="eachUserkycsArrayElement.status == 0" >Initiated</span>
                        </td>
                        <td>{{eachUserkycsArrayElement.updated_by_user?eachUserkycsArrayElement.updated_by_user.email: 'Auto'}}</td>
                        <td>{{eachUserkycsArrayElement.reason?eachUserkycsArrayElement.reason:'N/A'}}</td>
                        <td>{{ new Date(typeof(eachUserkycsArrayElement.updated_at) != 'undefined'?eachUserkycsArrayElement.updated_at: eachUserkycsArrayElement.created_at).toISOString().slice(0, 16).replace("T", " ") }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                <div class="row">
                  <div  class="col-12 d-flex justify-content-end p-2">
                    <button type="button" class="btn btn-primary btn-sm " @click="updateKycStatus">Update Status</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

      </section>
      <!-- users list ends -->

    </div>
    <MerchantKycUpdateStatusModal
        :show="showKycModal"
        :userkycs="userkycs"
        :id="kycId"
        :row="kycRow"
        :index="kycIndex"
        @hide="showKycModal = false"
        @statusUpdated="kycStatusUpdated"
    ></MerchantKycUpdateStatusModal>
  </div>
</template>

<script>
import MerchantAccountUpdateStatusModal from "@/pages/dashboard/merchant/MerchantAccountUpdateStatusModal";
import MerchantKycUpdateStatusModal from "@/pages/dashboard/merchant/MerchantKycUpdateStatusModal";
export default {
  props: ['id'],
  components:{
    MerchantAccountUpdateStatusModal,MerchantKycUpdateStatusModal
  },
  mounted() {
    this.sendCall()
  },
  data() {
    return {
      userRoles: [],
      accounts: [],
      cards: [],
      userkycs: [],
      accountId:'',
      accountStatus:'',
      accountIndex:'',
      accountRow:'',
      showModal: false,
      showKycModal: false,
      kycId:'',
      kycStatus:'',
      kycIndex:'',
      kycRow:'',
    }
  },
  methods: {
    backTo(){
      this.$emit('hide')
    },
    statusUpdated(status){
      this.showModal = false
      this.accounts[this.accountIndex].status = status
    },
    kycStatusUpdated(){
      this.showKycModal = false
      this.sendCall()
    },
    updateStatus(account,accountIndex){
      this.accountId = account.id
      this.accountRow = account
      this.accountIndex = accountIndex
      this.accountStatus = account.status
      this.showModal = true
    },
    updateKycStatus(){
      this.showKycModal = true
    },
    sendCall() {
      this.makeRequest('post', 'v1/detail-merchant', {id: this.id}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(data){
              this.kycId = data.id
              this.userRoles = data.user_roles
              this.accounts = data.accounts
              this.cards = data.cards
              this.userkycs = data?.userkycs ?? []
            }

          }
        }

      });

    },
  },

}
</script>


